import React, { useState, useEffect } from 'react';
import { ContentBox } from '../ContentBox';
import { SingleInput, SingleText } from '../../Res/BaseInput';
import { SubmitButton } from '../../Res/BaseButton';
import { RespResumeOtherDataFamilyList, RespResumeOtherDataEmergencyContact, RespResumeOtherDataFamily, RespResumeOtherData } from '../../../../item/ItemResume';
import { api_addResumeOtherData } from '../../../../api/apiResume';
import Swal from 'sweetalert2';

export const OtherData_family = "family"
export function ContractorResumeFamily({ rId, familys, companyId, setIsLoading, isEdit, isEmployee=false }) {
    const [resumeId, setResumeId] = useState("")
    const [mFamilys, setFamilys] = useState({})

    const [mFamilyList, setFamilyList] = useState([])
    const [mEmergencyContact, setEmergencyContact] = useState({})


    useEffect(() => {
        if (rId !== undefined && rId !== "" && rId !== resumeId) {
            setResumeId(rId)
            //console.log(rId)
            //getResumeOtherData(rId)
        }
    }, [rId])

    useEffect(() => {
        if (familys !== undefined && familys !== mFamilys && Object.keys(familys).length !== 0) {
            setFamilys(familys)
            //console.log(familys)
            var mRespResumeOtherDataFamily = new RespResumeOtherDataFamily({})
            mRespResumeOtherDataFamily.fromJson(familys.resumeData)
            //console.log(mRespResumeOtherDataFamily)
            setFamilyList(mRespResumeOtherDataFamily.familyList)
            setEmergencyContact(mRespResumeOtherDataFamily.emergencyContact)
        }
    }, [familys])

    function setFamily(index, family) {
        mFamilyList[index] = family
        setFamilyList(mFamilyList)
    }

    function setContact(contact) {
        setEmergencyContact(contact)
    }


    /*
    function getResumeOtherData(resumeId) {
        var mReqResumeOtherData = new ReqResumeOtherData({
            resumeId,
            resumeKey: OtherData_family
        })
        //console.log(mReqResumeOtherData)
        api_getResumeOtherData({
            mReqResumeOtherData,
            success: (jsonData) => {
                //console.log(jsonData.info.resumeData)
                var mRespResumeOtherDataFamily = new RespResumeOtherDataFamily({})
                mRespResumeOtherDataFamily.fromJson(jsonData.info.resumeData)
                //console.log(mRespResumeOtherDataFamily.emergencyContact)
                setFamilyList(mRespResumeOtherDataFamily.familyList)
                setEmergencyContact(mRespResumeOtherDataFamily.emergencyContact)
                setIsLoading(false)
            },
            failure: (err) => {
                setIsLoading(false)
            }
        })
    }
    */

    async function saveOtherDataFamily() {
        //console.log("saveOtherData")
        var mRespResumeOtherData = new RespResumeOtherData({
            companyId,
            resumeId,
            resumeKey: OtherData_family,
            resumeData: JSON.stringify(new RespResumeOtherDataFamily({
                familyList: mFamilyList,
                emergencyContact: mEmergencyContact
            })),
        })
        //console.log(mRespResumeOtherData)
        try {
            await api_addResumeOtherData({
                mRespResumeOtherData,
                isEmployee
            })
            Swal.fire({
                type: 'success',
                title: '提醒',
                text: "儲存成功",
            })
        } catch (error) {
            console.log(error)
        }
    }


    var familyTitle = "家庭成員"
    var familyContent =
        <>
            {
                mFamilyList.map((f, i) => (
                    <FamilyItems key={"f" + i} index={i} family={f} setFamily={setFamily} isEdit={isEdit} />
                ))
            }
            <EmergencyContactItems emergencyContact={mEmergencyContact} setEmergencyContact={setContact} isEdit={isEdit} />
            {isEdit ?
                <>
                    <div className="hr-line-dashed"></div>
                    <div className="row text-right ">
                        <div className="col-sm-12">
                            <SubmitButton name={"儲存"} action={saveOtherDataFamily} isRight={true} />
                        </div>
                    </div>
                </>
                : <></>
            }
        </>


    return (
        <>
            <ContentBox title={familyTitle} content={familyContent} hasDrawer={true} />
        </>
    )
}

function FamilyItems({ index, family, setFamily, isEdit }) {
    const [mFamily, setF] = useState(new RespResumeOtherDataFamilyList({}))
    const [name, setName] = useState("")
    const [relation, setRelation] = useState("")
    const [birthYear, setBirthYear] = useState("")
    const [job, setJob] = useState("")

    useEffect(() => {
        console.log(index)
        if (family !== undefined && family !== mFamily) {
            setF(family)
            setName(family.name)
            setRelation(family.relation)
            setBirthYear(family.birthYear)
            setJob(family.job)
        }
    }, [family])

    function setN(val) {
        setName(val)
        mFamily.name = val
        setFamily(index, mFamily)
    }
    function setR(val) {
        setRelation(val)
        mFamily.relation = val
        setFamily(index, mFamily)
    }
    function setB(val) {
        setBirthYear(val)
        mFamily.birthYear = val
        setFamily(index, mFamily)
    }
    function setJ(val) {
        setJob(val)
        mFamily.job = val
        setFamily(index, mFamily)
    }

    return (
        <>
            <div className="row  m-b-sm">
                <div className="col-md-12">
                    {isEdit ?
                        <SingleInput title={"姓名"} val={name} action={setN} placeholder={"王大同"} />
                        : <SingleText title={"姓名"} val={name} />
                    }
                    {isEdit ?
                        <SingleInput title={"關係"} val={relation} action={setR} placeholder={"父子"} />
                        : <SingleText title={"關係"} val={relation} />
                    }
                    {isEdit ?
                        <SingleInput title={"出生年次"} val={birthYear} action={setB} placeholder={"1971"} />
                        : <SingleText title={"出生年次"} val={birthYear} />
                    }
                    {isEdit ?
                        <SingleInput title={"職業"} val={job} action={setJ} placeholder={"自由業"} />
                        : <SingleText title={"職業"} val={job} />
                    }
                </div>
            </div>
            <div className="hr-line-dashed"></div>
        </>
    )
}

function EmergencyContactItems({ emergencyContact, setEmergencyContact, isEdit }) {
    const [mEmergencyContact, setE] = useState(new RespResumeOtherDataEmergencyContact({}))
    const [name, setName] = useState("")
    const [relation, setRelation] = useState("")
    const [mobile, setMobile] = useState("")
    const [phone, setPhone] = useState("")

    useEffect(() => {
        if (emergencyContact !== undefined && emergencyContact !== mEmergencyContact) {
            setE(emergencyContact)
            setName(emergencyContact.name)
            setRelation(emergencyContact.relation)
            setMobile(emergencyContact.mobile)
            setPhone(emergencyContact.phone)
        }
    }, [emergencyContact])

    function setN(val) {
        setName(val)
        mEmergencyContact.name = val
        setEmergencyContact(mEmergencyContact)
    }
    function setR(val) {
        setRelation(val)
        mEmergencyContact.relation = val
        setEmergencyContact(mEmergencyContact)
    }
    function setM(val) {
        setMobile(val)
        mEmergencyContact.mobile = val
        setEmergencyContact(mEmergencyContact)
    }
    function setP(val) {
        setPhone(val)
        mEmergencyContact.phone = val
        setEmergencyContact(mEmergencyContact)
    }

    return (
        <div className="row  m-b-sm">
            <div className="col-md-12">
                {isEdit ?
                    <SingleInput title={"緊急聯絡人姓名"} val={name} action={setN} placeholder={"王大同"} />
                    : <SingleText title={"緊急聯絡人姓名"} val={name} />
                }
                {isEdit ?
                    <SingleInput title={"關係"} val={relation} action={setR} placeholder={"父子"} />
                    : <SingleText title={"關係"} val={relation} />
                }
                {isEdit ?
                    <SingleInput title={"手機號碼"} val={mobile} action={setM} placeholder={"0988123456"} />
                    : <SingleText title={"手機號碼"} val={mobile} />
                }
                {isEdit ?
                    <SingleInput title={"市內電話"} val={phone} action={setP} placeholder={"0227208889"} />
                    : <SingleText title={"市內電話"} val={phone} />
                }
            </div>
        </div>
    )
}